import React, { FC, Fragment } from 'react';
import { Text, Box, Avatar } from '@bechtel/gds';
import { CrewSupervisorStyled } from './styled';
import { TimesheetCrewSupervisorItemProps } from './types';
import { useName, PersonaMessages } from '@bechtel/client-common';
import { useLingui } from '@lingui/react';
import { map, capitalize } from 'lodash';
import { TimesheetStatusCrewMember } from '@bechtel/types';
import { TimesheetCrewItem } from '../crew-item';

export const TimesheetCrewSupervisorItem: FC<TimesheetCrewSupervisorItemProps> = ({ timesheetStatusCrewMember }) => {
  const { getFullName } = useName();
  const { i18n } = useLingui();
  const { crewMember, directReports } = timesheetStatusCrewMember;
  return (
    <Fragment>
      <CrewSupervisorStyled>
        <Avatar src={crewMember?.imageUrl ? crewMember?.imageUrl : undefined} />
        <Box flexDirection={{ sm: 'column' }} ml={{ sm: '400' }}>
          <Text size="400" weight="600" color="grey.1000">
            {getFullName(crewMember?.firstName, crewMember?.lastName)}
          </Text>
          <Box mt={{ sm: '200' }}>
            <Text size="300" color="grey.600">
              {i18n._(PersonaMessages[crewMember?.persona].id)}
              {crewMember?.crew?.crewNumber ? ` - ${crewMember?.crew?.crewNumber} / ` : ''}
              {capitalize(crewMember?.discipline)}
            </Text>
          </Box>
        </Box>
      </CrewSupervisorStyled>
      {map(directReports, (crewItem: TimesheetStatusCrewMember) => {
        return <TimesheetCrewItem key={crewItem.crewMember?.id} timesheetStatusCrewMember={crewItem} />;
      })}
    </Fragment>
  );
};
